var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroMacros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6l8 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6l4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12l2 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12l10 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18l11 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18l1 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMacros);
export default __webpack_public_path__ + "static/media/hero-macros.84170f7024889f5cbfefa3dfb6b6b6f6.svg";
export { ForwardRef as ReactComponent };